import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import HeroGuide from "../../Components/HeroGuide/HeroGuide";
import CardsGeneral from "./Components/CardsGeneral";

export default function General() {
  return (
    <LayoutPage
      activeIndex={10}
      navItems={["گواهی‌نامه‌ها"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["معرفی گواهی‌نامه‌ها", "گواهی‌نامه‌های شما"]}
        hrefs={["/certificate/general", "/certificate/for-you"]}
        activeIndex={0}
      />
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <HeroGuide
          title="گواهی‌نامه خودتو به دست بیار!"
          h1="شرکت در چالش"
          h2="دریافت گواهی"
          h3="اشتراک گذاری"
          icon1="test"
          icon2="certificate"
          icon3="share"
          text1="با مطالعه راهنمای گواهی‌نامه || مأموریت‌های چالش را پاس کنید"
          text2="بعد از انجام مأموریت‌های چالش || گواهی‌نامه‌ها باز می‌شوند"
          text3="فایل گواهی‌ را دانلود کرده یا از || همین بخش آن را به اشتراک بگذارید"
        />
        <CardsGeneral />
      </div>
    </LayoutPage>
  );
}
